import { IconProps } from "./Icon.model";

export function ApiKeyIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 2C12.4624 2 10 4.46243 10 7.5C10 8.18813 10.1266 8.84651 10.3578 9.45316L2.29289 17.5181C2.10536 17.7056 2 17.9599 2 18.2252V21C2 21.5523 2.44772 22 3 22H7C7.55228 22 8 21.5523 8 21V19.5H9.5C10.0523 19.5 10.5 19.0523 10.5 18.5V17H12C12.2652 17 12.5196 16.8946 12.7071 16.7071L14.5468 14.8674C15.1535 15.0984 15.8119 15.225 16.5 15.225C19.5376 15.225 22 12.7626 22 9.725C22 6.41243 19.5376 4 16.5 4L15.5 2ZM16 6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10C17.1046 10 18 9.10457 18 8C18 6.89543 17.1046 6 16 6Z"
        fill={fillColor}
      />
    </svg>
  );
}
